import React from 'react';
import { render } from 'react-dom';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { selectYourXDropdownToggle } from '../actions/selectYourXDropdownsActions';
import { dropdownIndex } from '../actions/selectYourXIndexActions';
import { brandSelected } from '../actions/brandActions';
import { withRouter } from 'react-router';

class FeaturedBrandList extends React.Component {
    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
    }
    onClick(brandId) {
        this.props.selectYourXDropdownToggle(dropdownIndex.brand);
        this.props.brandSelected(brandId, this.props.finderTypeId);
        window.scrollTo(0, 0);
    }
    render() {
        
        return (
            <div>
                {this.props.data[0].map(brand => (
                    <div className="top-brand-wrapper" key={brand.description}>
                        
                        <Link
                            to={{ pathname: '/' + encodeURIComponent(brand.description), search: this.props.location.search }}
                            onClick={() => this.onClick(brand.description)}
                        >
                            <img src={brand.filterValueGraphic} alt={brand.description} />
                        </Link>
                        
                    </div>
                ))
                }
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        finderTypeId: state.finderTypeId
    };
}
function mapDispatchToProps(dispatch) {
    return {
        selectYourXDropdownToggle: (e) => dispatch(selectYourXDropdownToggle(e)),
        brandSelected: (e, finderType) => dispatch(brandSelected(e, finderType))
    };
}
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(FeaturedBrandList));